import { createContext, useContext } from "react";

/**
 * Heading level for card titles: 2 directly under the page h1, 3 inside a
 * section that brings its own h2 (PortalSection).
 */
export const SectionHeadingLevelContext = createContext<2 | 3>(2);

export const useSectionHeadingLevel = () =>
  useContext(SectionHeadingLevelContext);
